module.exports = __webpack_public_path__ + "img/play.3ace6ffe.svg";